import React, { useCallback } from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../components/components"
import { getLaenderCodes } from "../constants"
import { EventBus } from "../eventbus"
import { FeatureService } from "../services/FeatureService"
import { RechnungsempfaengerKontaktdatenView } from "./RechnungsempfaengerKontaktdatenView"
import { useStoreRechnung } from "../store"

interface RechnungspersonViewProps {
    basePath: string
}

export function RechnungsempfaengerView({ basePath }: RechnungspersonViewProps) {
    const laenderOptions = getLaenderCodes()
    const { t } = useTranslation()
    const {
        rechnungsempfaenger: { empfaenger },
    } = useStoreRechnung("rechnungsempfaenger")

    const onChange = useCallback<(path: string) => (value: unknown) => void>(
        (path) => (value) => {
            EventBus.instance.emit("changeProperty", `${basePath}.${path}`, value)
        },
        [basePath],
    )

    return (
        <Components.Collapsible title={t("rechnung.rechnungsempfaenger.title")} collapsed={false}>
            <Components.FormGroup label={t("rechnung.rechnungsempfaenger.unternehmen.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsempfaenger.unternehmen.placeholder")}
                    onChange={onChange("unternehmen")}
                    value={empfaenger.unternehmen}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsempfaenger.anschrift.strasse1.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsempfaenger.anschrift.strasse1.placeholder")}
                    onChange={onChange("anschrift.strasse1")}
                    value={empfaenger.anschrift.strasse1}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsempfaenger.anschrift.strasse2.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsempfaenger.anschrift.strasse2.placeholder")}
                    onChange={onChange("anschrift.strasse2")}
                    value={empfaenger.anschrift.strasse2}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsempfaenger.anschrift.strasse3.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsempfaenger.anschrift.strasse3.placeholder")}
                    onChange={onChange("anschrift.strasse3")}
                    value={empfaenger.anschrift.strasse3}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsempfaenger.anschrift.ort.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsempfaenger.anschrift.ort.placeholder")}
                    onChange={onChange("anschrift.ort")}
                    value={empfaenger.anschrift.ort}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsempfaenger.anschrift.plz.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsempfaenger.anschrift.plz.placeholder")}
                    onChange={onChange("anschrift.plz")}
                    value={empfaenger.anschrift.plz}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsempfaenger.anschrift.land.label")}>
                <Components.MultiSelect
                    placeholder={t("rechnung.rechnungsempfaenger.anschrift.land.placeholder")}
                    onChange={onChange("anschrift.land")}
                    value={laenderOptions.find((o) => o.value === empfaenger.anschrift?.land)}
                    options={laenderOptions}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsempfaenger.eindeutigeKennung.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsempfaenger.eindeutigeKennung.placeholder")}
                    onChange={onChange("eindeutigeKennung")}
                    value={empfaenger.eindeutigeKennung}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsempfaenger.umsatzsteuerId.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsempfaenger.umsatzsteuerId.placeholder")}
                    onChange={onChange("umsatzsteuerId")}
                    value={empfaenger.umsatzsteuerId}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsempfaenger.eRechnungsAdresse.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsempfaenger.eRechnungsAdresse.placeholder")}
                    onChange={onChange("eRechnungsAdresse")}
                    value={empfaenger.eRechnungsAdresse}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsempfaenger.abweichenderHandelsname.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsempfaenger.abweichenderHandelsname.placeholder")}
                    onChange={onChange("abweichenderHandelsname")}
                    value={empfaenger.abweichenderHandelsname}
                />
            </Components.FormGroup>

            {!FeatureService.isFeatureActive("DEMO") && <RechnungsempfaengerKontaktdatenView basePath={`${basePath}.kontaktdaten`} />}
        </Components.Collapsible>
    )
}
